import { DeliveryDetailsValues } from './DeliveryDetails.types'

export const deliveryDetailsInitialValues: DeliveryDetailsValues = {
  streetAddress: '',
  country: '',
  city: '',
  administrativeDivision: '',
  postalCode: ''
}

export const administrativeDivisionLabels: Record<string, string> = {
  US: 'State',
  CA: 'Province',
  AU: 'State/Territory',
  GB: 'County',
  FR: 'Region',
  DE: 'State',
  BR: 'State',
  MX: 'State',
  IN: 'State/UT',
  CN: 'Province',
  JP: 'Prefecture',
  KR: 'Province',
  ES: 'Province',
  IT: 'Region',
  NL: 'Province',
  BE: 'Province',
  CH: 'Canton',
  AT: 'State',
  SE: 'County',
  NO: 'County',
  DK: 'Region',
  FI: 'Region',
  PL: 'Voivodeship',
  RU: 'Region',
  ZA: 'Province',
  NZ: 'Region',
  AR: 'Province',
  CL: 'Region',
  CO: 'Department',
  PE: 'Department',
  VE: 'State',
  PH: 'Province',
  TH: 'Province',
  VN: 'Province',
  ID: 'Province',
  MY: 'State',
  SG: 'District',
  AE: 'Emirate',
  SA: 'Province',
  EG: 'Governorate',
  IL: 'District',
  TR: 'Province',
  GR: 'Region',
  PT: 'District',
  IE: 'County',
  CZ: 'Region',
  HU: 'County',
  RO: 'County',
  BG: 'Province',
  HR: 'County',
  RS: 'District',
  SK: 'Region',
  SI: 'Region',
  EE: 'County',
  LV: 'Region',
  LT: 'County',
  UA: 'Oblast',
  BY: 'Region',
  KZ: 'Region',
  UZ: 'Region',
  PK: 'Province',
  BD: 'Division',
  LK: 'Province',
  MM: 'State/Region',
  KH: 'Province',
  LA: 'Province',
  HK: 'District',
  TW: 'County/City',
  NG: 'State',
  KE: 'County',
  GH: 'Region',
  MA: 'Region',
  TN: 'Governorate',
  DZ: 'Province',
  ET: 'Region',
  UG: 'District',
  TZ: 'Region',
  ZW: 'Province',
  BW: 'District',
  NA: 'Region',
  MZ: 'Province',
  AO: 'Province',
  ZM: 'Province'
}
